export default "__VITE_ASSET__CZPDxYQ5__"